import get from 'lodash/get'
import styled from 'styled-components'

const ShellView = styled.div`
  display: flex;
  flex-direction: column;
  background: ${props => get(props.theme, 'shell.body.backgroundColor')};
  min-height: 100vh;
`

export default ShellView
